// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".base-radio-group[data-v-52e11e80] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 18px;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.base-radio-group .el-radio[data-v-52e11e80] {\n  min-width: 100px;\n}", ""]);
// Exports
module.exports = exports;
